import { jsx as L } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ L(
  "path",
  {
    d: "M23 11.46L20.56 8.68L20.9 5L17.29 4.18L15.4 1L12 2.46L8.6 1L6.71 4.18L3.1 4.99L3.44 8.67L1 11.46L3.44 14.24L3.1 17.93L6.71 18.75L8.6 21.93L12 20.46L15.4 21.92L17.29 18.74L20.9 17.92L20.56 14.24L23 11.46ZM10 16.46L6 12.46L7.41 11.05L10 13.63L16.59 7.04L18 8.46L10 16.46Z",
    fill: "currentColor"
  }
);
export {
  t as default
};
